webpackJsonp([47],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_viewerjs__);
//
//
//
//
//
//
//
//
//
//
//




// View an image
var viewer = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {
      visible: false,
      action: '',
      files: [],
      index: null
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      if (this.visible) {
        this.view(this.index);
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {
    this.destroyViewer();
  },

  methods: {
    view: function view(index) {
      var _this = this;

      this.$nextTick(function () {
        _this.createViewer();
        viewer.view(index);
        viewer.show();
      });
    },
    createViewer: function createViewer() {
      this.destroyViewer();
      viewer = new __WEBPACK_IMPORTED_MODULE_1_viewerjs___default.a(this.$el, {
        url: function url(image) {
          return image.alt + '?x-oss-process=image/auto-orient,1';
        },
        hidden: this.onClose
      });
    },
    destroyViewer: function destroyViewer() {
      viewer && viewer.destroy();
    },
    handleAction: function handleAction(action) {
      this.action = action;
      this.doClose();
    },
    onClose: function onClose() {
      if (!this.visible) return;
      this.handleAction('close');
    },
    doClose: function doClose() {
      var _this2 = this;

      if (!this.visible) return;
      this.visible = false;
      setTimeout(function () {
        if (_this2.action) _this2.callback(_this2.action, _this2);
      });
    }
  }
});

/***/ }),

/***/ 1768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_TYPE_ALG; });
/* unused harmony export APP_TYPE_CLB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appTypeOptions; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getAppTypeLabel;
/**
 * 上架 App 类型
 */
var APP_TYPE_ALG = 1;
var APP_TYPE_CLB = 2;

var appTypeOptions = [{ value: APP_TYPE_ALG, label: '爱零工' }, { value: APP_TYPE_CLB, label: '查理宝' }];

function getAppTypeLabel(value) {
  var item = appTypeOptions.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

/***/ }),

/***/ 1885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(1886);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 1886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImageViewBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(1887);



var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var defaultCallback = function defaultCallback(action) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(action);
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(action);
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
      };

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var ImageViewBox = function ImageViewBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
  if (options.constructor === Array) {
    options = {
      files: options
    };
    if (typeof arguments[1] === 'number') {
      options.index = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  currentBox = {
    options: _.merge({}, defaults, ImageViewBox.defaults, options),
    callback: callback
  };

  showBox();
};

ImageViewBox.setDefaults = function (defaults) {
  ImageViewBox.defaults = defaults;
};

ImageViewBox.open = function (files, index, options) {
  return ImageViewBox(_.merge({
    files: files,
    index: index
  }, options));
};

ImageViewBox.close = function () {
  instance.doClose();
  instance.visible = false;
  currentBox = null;
};

ImageViewBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ImageViewBox);



/***/ }),

/***/ 1887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9bcfb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1894);
function injectStyle (ssrContext) {
  __webpack_require__(1888)
  __webpack_require__(1890)
  this["$style"] = __webpack_require__(1892)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e9bcfb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9bcfb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1888:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1889);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a510c2b0", content, true, {});

/***/ }),

/***/ 1889:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1890:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1891);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d79080d4", content, true, {});

/***/ }),

/***/ 1891:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1892:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1893);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("12c3a25e", content, true, {});

/***/ }),

/***/ 1893:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"display":"none"}},_vm._l((_vm.files),function(ref){
var src = ref.src;
return _c('li',[_c('img',{ref:"img",refInFor:true,attrs:{"src":_vm._f("ossThumbnail")(src,75),"alt":src}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的任务提示ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  app_type: [{ required: true, message: '请选择上架APP', trigger: 'change' }],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入提示名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })],
  projectid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择项目', 'integer'))],
  templateid: [{ validator: function validator(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error('请至少选择一个分步模板'));
      } else {
        callback();
      }
    } }],
  notice_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择提示类型', 'integer'))]
};

/***/ }),

/***/ 2994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__task_notice_rules_js__ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AvatarUploader__ = __webpack_require__(5469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_appType__ = __webpack_require__(1768);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AvatarUploader: __WEBPACK_IMPORTED_MODULE_4__components_AvatarUploader__["a" /* default */]
  },
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_3__task_notice_rules_js__["a" /* formRules */],
      appTypeOptions: __WEBPACK_IMPORTED_MODULE_5__utils_appType__["b" /* appTypeOptions */],
      imageUrl: '',
      form: {
        app_type: __WEBPACK_IMPORTED_MODULE_5__utils_appType__["a" /* APP_TYPE_ALG */],
        title: '',
        images: [''],
        notice_type: 1,
        content: '',
        projectid: null,
        templateid: []
      }
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request.map(['getProjectTable', 'getProjectDetail', 'getStepTemplateTable', 'getStepTemplateDetail', 'uploadTaskNoticeFile']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getTaskNoticeDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        // 兼容处理：支持数组和单个值
        var templateIds = [];
        if (Array.isArray(data.templateid)) {
          templateIds = data.templateid.map(function (id) {
            return String(id);
          });
        } else if (data.templateid) {
          templateIds = [String(data.templateid)];
        }
        data.projectid += '';
        filter.setLoop(_this.form, data);

        // 在设置 templateid 之前，先预加载所有模板详情到 RemoteSelect 的 items 中
        if (templateIds.length > 0) {
          // 预加载所有模板详情
          var promises = templateIds.map(function (templateId) {
            return _this.getStepTemplateDetail({ id: templateId }).then(function (_ref2) {
              var data = _ref2.data;
              return data;
            });
          });
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (results) {
            // 所有模板详情加载完成后，手动添加到 RemoteSelect 的 items 中
            _this.$nextTick(function () {
              if (_this.$refs.templateSelect) {
                results.forEach(function (data) {
                  var item = _this.$refs.templateSelect.findOption({ id: data.id });
                  if (!item) {
                    _this.$refs.templateSelect.items.push(data);
                  }
                });
              }
              // 然后设置值
              _this.$set(_this.form, 'templateid', templateIds);
            });
          }).catch(function () {
            // 即使加载失败，也设置值
            _this.$set(_this.form, 'templateid', templateIds);
          });
        } else {
          _this.$set(_this.form, 'templateid', templateIds);
        }
      });
    },
    getForm: function getForm() {
      this.form.images = this.form.images.filter(function (one) {
        return !!one;
      });
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createTaskNoticeData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/task-notice/table/' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('updateTaskNoticeData', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/task-notice/table/' });
        });
      });
    }
  })
});

/***/ }),

/***/ 2995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_image_view_box__ = __webpack_require__(1885);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: String,
    accept: String,
    disabled: {
      type: Boolean,
      default: false
    },
    request: {
      type: Function
    },
    maxSize: Number
  },
  computed: {
    fileTypes: function fileTypes() {
      return this.accept.replaceAll('.', '').replaceAll(',', '/').toUpperCase();
    }
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.$emit('input', res.data);
    },
    sendRequest: function sendRequest(options) {
      var form = new FormData();
      form.append('file', options.file);
      return this.request(form);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var sizeAllowed = !this.maxSize || file.size / 1024 / 1024 < this.maxSize;

      if (!sizeAllowed) {
        this.$message.error('\u4E0A\u4F20\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ' + this.maxSize + 'MB!');
      }

      return sizeAllowed;
    },
    remove: function remove() {
      this.$emit('input', '');
    },
    view: function view() {
      __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_image_view_box__["a" /* default */].open([{ src: this.value }], 0);
    }
  }
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskNoticeForm_vue__ = __webpack_require__(2994);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298d980a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskNoticeForm_vue__ = __webpack_require__(5473);
function injectStyle (ssrContext) {
  __webpack_require__(5463)
  __webpack_require__(5465)
  this["$style"] = __webpack_require__(5467)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-298d980a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskNoticeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298d980a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskNoticeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5463:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5464);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4b837ad5", content, true, {});

/***/ }),

/***/ 5464:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskNoticeForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5465:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5466);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("104018e2", content, true, {});

/***/ }),

/***/ 5466:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskNoticeForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5467:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5468);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("e1a4726a", content, true, {});

/***/ }),

/***/ 5468:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskNoticeForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvatarUploader_vue__ = __webpack_require__(2995);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e72509f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvatarUploader_vue__ = __webpack_require__(5472);
function injectStyle (ssrContext) {
  __webpack_require__(5470)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e72509f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvatarUploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e72509f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvatarUploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5470:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5471);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2311897b", content, true, {});

/***/ }),

/***/ 5471:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".avatar-uploader .el-uploader[data-v-e72509f2] .el-upload{cursor:pointer;border-radius:6px;border:1px dashed #d9d9d9}.avatar-uploader .el-uploader[data-v-e72509f2] .el-upload:hover{border-color:#409eff}.avatar-uploader .el-uploader[data-v-e72509f2] .el-upload .avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar-uploader .avatar[data-v-e72509f2]{border-radius:6px;border:1px dashed #409eff;position:relative;overflow:hidden;width:178px;height:178px;display:block}.avatar-uploader .el-upload-list__item-actions[data-v-e72509f2]{border-radius:6px;position:absolute;width:178px;height:178px;left:1px;top:1px;cursor:pointer;text-align:center;color:#fff;opacity:0;font-size:20px;background-color:rgba(0,0,0,.5);-webkit-transition:opacity .3s;transition:opacity .3s}.avatar-uploader .el-upload-list__item-actions span[data-v-e72509f2]{display:none;cursor:pointer}.avatar-uploader .el-upload-list__item-actions span+span[data-v-e72509f2]{margin-left:15px}.avatar-uploader .el-upload-list__item-actions[data-v-e72509f2]:hover{opacity:1}.avatar-uploader .el-upload-list__item-actions:hover span[data-v-e72509f2]{display:inline-block}.avatar-uploader .el-upload-list__item-actions[data-v-e72509f2]:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.avatar-uploader .el-upload-list__item-delete[data-v-e72509f2]{position:static;font-size:inherit;color:inherit}", "", {"version":3,"sources":["/workspace/src/views/task-notice/components/AvatarUploader.vue"],"names":[],"mappings":"AACA,0DAA0D,eAAe,kBAAkB,yBAAyB,CACnH,AACD,gEAAgE,oBAAoB,CACnF,AACD,gFAAgF,eAAe,cAAc,YAAY,aAAa,kBAAkB,iBAAiB,CACxK,AACD,0CAA0C,kBAAkB,0BAA0B,kBAAkB,gBAAgB,YAAY,aAAa,aAAa,CAC7J,AACD,gEAAgE,kBAAkB,kBAAkB,YAAY,aAAa,SAAS,QAAQ,eAAe,kBAAkB,WAAW,UAAU,eAAe,gCAAiC,+BAA+B,sBAAsB,CACxS,AACD,qEAAqE,aAAa,cAAc,CAC/F,AACD,0EAA0E,gBAAgB,CACzF,AACD,sEAAsE,SAAS,CAC9E,AACD,2EAA2E,oBAAoB,CAC9F,AACD,sEAAuE,qBAAqB,WAAW,YAAY,qBAAqB,CACvI,AACD,+DAA+D,gBAAgB,kBAAkB,aAAa,CAC7G","file":"AvatarUploader.vue","sourcesContent":["\n.avatar-uploader .el-uploader[data-v-e72509f2] .el-upload{cursor:pointer;border-radius:6px;border:1px dashed #d9d9d9\n}\n.avatar-uploader .el-uploader[data-v-e72509f2] .el-upload:hover{border-color:#409EFF\n}\n.avatar-uploader .el-uploader[data-v-e72509f2] .el-upload .avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center\n}\n.avatar-uploader .avatar[data-v-e72509f2]{border-radius:6px;border:1px dashed #409EFF;position:relative;overflow:hidden;width:178px;height:178px;display:block\n}\n.avatar-uploader .el-upload-list__item-actions[data-v-e72509f2]{border-radius:6px;position:absolute;width:178px;height:178px;left:1px;top:1px;cursor:pointer;text-align:center;color:#fff;opacity:0;font-size:20px;background-color:rgba(0,0,0,0.5);-webkit-transition:opacity .3s;transition:opacity .3s\n}\n.avatar-uploader .el-upload-list__item-actions span[data-v-e72509f2]{display:none;cursor:pointer\n}\n.avatar-uploader .el-upload-list__item-actions span+span[data-v-e72509f2]{margin-left:15px\n}\n.avatar-uploader .el-upload-list__item-actions[data-v-e72509f2]:hover{opacity:1\n}\n.avatar-uploader .el-upload-list__item-actions:hover span[data-v-e72509f2]{display:inline-block\n}\n.avatar-uploader .el-upload-list__item-actions[data-v-e72509f2]::after{display:inline-block;content:\"\";height:100%;vertical-align:middle\n}\n.avatar-uploader .el-upload-list__item-delete[data-v-e72509f2]{position:static;font-size:inherit;color:inherit\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"avatar-uploader"},[(_vm.value)?_c('div',{staticStyle:{"position":"relative"}},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.value}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions"},[_c('span',{staticClass:"el-upload-list__item-preview"},[_c('i',{staticClass:"el-icon-zoom-in",on:{"click":_vm.view}})]),_vm._v(" "),(!_vm.disabled)?_c('span',{staticClass:"el-upload-list__item-delete"},[_c('i',{staticClass:"el-icon-delete",on:{"click":_vm.remove}})]):_vm._e()])]):_c('el-upload',{staticClass:"el-uploader",attrs:{"action":"","accept":_vm.accept,"disabled":_vm.disabled,"show-file-list":false,"http-request":_vm.sendRequest,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n        请上传"+_vm._s(_vm.fileTypes)+"文件，"),(_vm.maxSize > 0)?_c('span',[_vm._v("最大不得超过 "+_vm._s(_vm.maxSize)+"MB，")]):_vm._e(),_vm._v("仅支持上传1张图片\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/task-notice/table"}},[_vm._v("任务提示列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"上架APP","prop":"app_type"}},[_c('el-radio-group',{model:{value:(_vm.form.app_type),callback:function ($$v) {_vm.$set(_vm.form, "app_type", $$v)},expression:"form.app_type"}},_vm._l((_vm.appTypeOptions),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label)+"\n              ")])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提示名称","prop":"title"}},[_c('el-input',{model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"name","value-key":"id","placeholder":"请输入项目名称","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},model:{value:(_vm.form.projectid),callback:function ($$v) {_vm.$set(_vm.form, "projectid", $$v)},expression:"form.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分步模板","prop":"templateid"}},[_c('remote-select',{ref:"templateSelect",staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"title","value-key":"id","placeholder":"请输入模板名称/ID 关键字搜索","query-request":_vm.getStepTemplateTable,"find-request":_vm.getStepTemplateDetail},model:{value:(_vm.form.templateid),callback:function ($$v) {_vm.$set(_vm.form, "templateid", $$v)},expression:"form.templateid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提示类型","prop":"notice_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择提示类型"},model:{value:(_vm.form.notice_type),callback:function ($$v) {_vm.$set(_vm.form, "notice_type", $$v)},expression:"form.notice_type"}},_vm._l(([{label: '文字', value: 1}, {label: '图片', value: 2}, {label: '图文', value: 3}]),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),([1,3].includes(_vm.form.notice_type))?_c('el-form-item',{attrs:{"label":"提示文案","prop":"content"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"请输入内容","rows":5},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}})],1):_vm._e(),_vm._v(" "),([2,3].includes(_vm.form.notice_type))?_c('el-form-item',{attrs:{"label":"上传图片","prop":"images"}},[_c('avatar-uploader',{attrs:{"accept":".png,.jpeg,.jpg","max-size":1,"request":_vm.uploadTaskNoticeFile},model:{value:(_vm.form.images[0]),callback:function ($$v) {_vm.$set(_vm.form.images, 0, $$v)},expression:"form.images[0]"}})],1):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/task-notice-form.fd8b4e33f81c0b1765a8.js